import { ref, watch, computed } from '@vue/composition-api'

import useJwt from "@/auth/jwt/useJwt";
import CISSettingService from '@/services/cis-setting.service'

import store from "@/store";

export default function cisKeywordsList() {
  const refKeywordsTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'keyword', label: 'keyword', sortable: false },
    { key: 'type', label: 'type', sortable: false },
    { key: 'actions', sortable: false },
  ]
  const perPage = ref(10)
  const totalKeywords = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const listCtgSq = ref(1)

  const dataMeta = computed(() => {
    const localItemsCount = refKeywordsTable.value ? refKeywordsTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalKeywords.value,
    }
  })

  const reFetchData = () => {
    refKeywordsTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    reFetchData()
  })

  const fetchKeywords = (ctx, callback) => {
    
    CISSettingService.keywordList({
      search: searchQuery.value,
      pageNumber: currentPage.value - 1,
      pageSize: perPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      ctgSq: listCtgSq.value
    }).then(response => {
      if (response && response.data.success) {
        const { data, total } = response.data
        callback(data)
        totalKeywords.value = total
      }
    })
  }

  return {
    fetchKeywords,
    tableColumns,
    perPage,
    currentPage,
    totalKeywords,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refKeywordsTable,

    statusFilter,

    reFetchData,
    listCtgSq
  }
}
